import { render } from "./PartnerTransactions.vue?vue&type=template&id=f4f3d726&scoped=true"
import script from "./PartnerTransactions.vue?vue&type=script&lang=js"
export * from "./PartnerTransactions.vue?vue&type=script&lang=js"

import "./PartnerTransactions.vue?vue&type=style&index=0&id=f4f3d726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f3d726"]])

export default __exports__